import React from 'react';
import { any, arrayOf, func, string } from 'prop-types';
import { Column, Row } from 'simple-flexbox';
import { createUseStyles, useTheme } from 'react-jss';
import CollapsibleContent from '../collapsible/CollapsibleContent';
import { useSidebar } from '../../hooks/useSidebar';

const useStyles = createUseStyles({
  activeContainer: {
    backgroundColor: '#ff9b4433',
  },
  container: {
    display: 'flex',
    height: 56,
    cursor: 'pointer',
    backgroundColor: '#fff',

    '&:hover': {
      backgroundColor: ({ theme, isActive }) => (isActive ? '' : '#ff9b4433'),
    },
    paddingLeft: ({ level }) => 32 * level,
    transition: 'all 0.2s ease-in-out',
    borderEndEndRadius: '40px',
  },
  leftBar: {
    borderLeft: ({ theme, level }) =>
      level > 1 ? 'none' : `3px solid ${theme.color.darkGrayishBlue}`,
  },
  title: {
    fontSize: 16,
    lineHeight: '20px',
    letterSpacing: '0.2px',
    color: ({ theme, isActive }) => (isActive ? '#ff902f' : '#373a47'),
    marginLeft: 24,
  },
});

function MenuItemComponent({
  children,
  icon: Icon,
  id,
  items = [],
  level = 1,
  onClick,
  title,
}) {
  const theme = useTheme();
  const isCollapsible = children && children.length > 0;
  const { isExpanded, isActive, onItemClick } = useSidebar({
    isCollapsible,
    item: id,
    items,
  });
  const classes = useStyles({ theme, level, isActive });
  const classNameColumn = isActive ? classes.leftBar : '';
  const classNameContainer = [
    classes.container,
    isActive && classes.activeContainer,
  ].join(' ');
  const iconColor = isActive ? 'rgb(255, 144, 47)' : 'rgb(55, 58, 71)';

  function onItemClicked(e) {
    if (onClick) {
      onClick(e);
    }
    onItemClick();
  }

  return (
    <Column key={id} className={classNameColumn}>
      <Row
        vertical="center"
        onClick={onItemClicked}
        className={classNameContainer}
      >
        <Icon fill={iconColor} opacity={!isActive && '0.4'} />
        <span className={classes.title}>{title}</span>
      </Row>

      {isCollapsible && (
        <CollapsibleContent expanded={isExpanded}>
          {children.map((child) => child.type({ ...child.props }))}
        </CollapsibleContent>
      )}
    </Column>
  );
}

MenuItemComponent.defaultProps = {};

MenuItemComponent.propTypes = {
  children: any,
  icon: func,
  id: string,
  onClick: func,
  items: arrayOf(string),
  title: string,
};

export default MenuItemComponent;
